module.exports = __webpack_public_path__ + "img/1F1EE-1F1E8.06d371d2.svg";